import { useCallback, ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Typography } from 'antd';

import { ConfirmDeleteModal } from '@ohpen/enso-ui';
import { NoteResponse, ActionEntityType, notesDeleteNote } from '@pmp/api';
import { DeleteModalProps } from '@pmp/types';
import { createDeleteErrorException } from '@pmp/utils';

const { Text } = Typography;
export const NotesDeleteModal = ({ open, record, onClose, refreshTable, entityType }: DeleteModalProps<NoteResponse>): ReactElement => {
  const { t } = useTranslation();

  const onConfirmDelete = useCallback(() => {
    return record?.entityId && (entityType ?? record?.entityType)
      ? notesDeleteNote({
          path: { noteId: record.id },
          query: { entityId: record.entityId, entityType: (entityType ?? record?.entityType) as unknown as ActionEntityType },
        })
          .then(() => {
            onClose();
            refreshTable();
            return { description: t('global.notifications.xDeletedSuccessfully', { x: t('lender.firms.labels.notes') }) };
          })
          .catch(error => {
            onClose();
            return Promise.reject(createDeleteErrorException(error));
          })
      : Promise.reject(createDeleteErrorException({ title: t('global.errors.invalidRecord') }));
  }, [onClose, record, refreshTable, t, entityType]);
  return (
    <ConfirmDeleteModal
      title={t('global.labels.deleteX', { x: t('lender.firms.labels.notes') })}
      open={open}
      onConfirm={onConfirmDelete}
      onCancel={onClose}
    >
      <Text>
        <Trans i18nKey="global.labels.confirmDeleteX" values={{ x: record?.entityId }} components={{ italic: <i /> }} />
      </Text>
    </ConfirmDeleteModal>
  );
};
